import {testIdProps} from '@github-ui/test-id-props'
import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {ReactElement} from 'react'
import type {ListViewSectionFilterLinks} from './SectionFilterLink'

type ListViewSectionFiltersProps = {
  links: ListViewSectionFilterLinks
}

const ulStyles: BetterSystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
}

export const ListViewSectionFilters = ({links}: ListViewSectionFiltersProps) => {
  if (links.length < 1) return null

  return (
    <div {...testIdProps('list-view-section-filters')}>
      <Box as="ul" sx={ulStyles} className="list-style-none">
        {links.map((sectionFilterLink, index) => (
          <li key={`section-filter-${index}`} {...testIdProps(`list-view-section-filter-${index}`)}>
            {sectionFilterLink}
          </li>
        ))}
      </Box>
    </div>
  )
}

try{ ListViewSectionFilters.displayName ||= 'ListViewSectionFilters' } catch {}